import { JsTimeSpan } from "../../../../../../ViewModel/JsTimeSpan";

export const formatTimespan = (timespan: JsTimeSpan | undefined | null) => {
  if (timespan?.toString() === "" || !timespan) {
    return "";
  }

  const hours = timespan.Hours || 0;
  const minutes = timespan.Minutes || 0;

  const hoursText = hours.toString().padStart(2, "0");
  const minutesText = minutes.toString().padStart(2, "0");
  return `${hoursText}:${minutesText}`;
};
